import { render } from "./OpenShipmentsView.vue?vue&type=template&id=12e3830f&scoped=true"
import script from "./OpenShipmentsView.vue?vue&type=script&lang=js"
export * from "./OpenShipmentsView.vue?vue&type=script&lang=js"

import "./OpenShipmentsView.vue?vue&type=style&index=0&id=12e3830f&scoped=true&lang=css"

import exportComponent from "/Users/chrisfinlayson/Desktop/WORK/riverhawk-nest/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12e3830f"]])

export default __exports__